import React from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { defaultAuthToastContainerProps } from "../../config/reactToastifyDefaults";
import { useFormik } from "formik";

import { Button, Input } from "../../components/ui";
import AuthHeroPanel from "../../components/auth/AuthHeroPanel";
import { forgotPassword } from "../../utils";
import { forgotPasswordSchema } from "../../validators/authValidators";

export default function AuthForgotPasswordPage() {
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, helpers) => {
      try {
        const result = await forgotPassword(values.email);
        if (result?.success) {
          toast.success(result?.msg || "Reset link has been sent to your email.");
          helpers.resetForm();
        } else {
          toast.error(result?.error || result?.msg || "Failed to send reset link");
        }
      } catch (error) {
        toast.error("Failed to send reset link");
      }
    },
  });

  return (
    <section className="lg:flex min-h-screen">
      <div className="bg-white w-full lg:w-[38%] flex items-center justify-center px-5 sm:px-8 xl:px-12 py-8">
        <div className="w-full">
          <img src="/new-logo/logo.png" alt="Innlead" className="h-12 w-auto" />

          <h2 className="mt-8 text-h4 font-semibold text-black">Forgot Your Password?</h2>
          <p className="mt-2 text-sm text-black/60">Fill the form to reset your password</p>

          <form onSubmit={formik.handleSubmit} className="mt-8 flex flex-col gap-5">
            <Input
              label="Your Email address *"
              id="forgot-email"
              placeholder="Email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email ? formik.errors.email : ""}
            />

            <Button
              variant="primary"
              fullWidth
              size="lg"
              type="submit"
              disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
            >
              Send Reset Link
            </Button>
          </form>

          <p className="mt-4 text-sm text-black/60">
            Return to{" "}
            <Link to="/login" className="text-brand-blue font-medium underline">
              Sign in
            </Link>
          </p>

          <ToastContainer {...defaultAuthToastContainerProps} />
        </div>
      </div>

      <AuthHeroPanel />
    </section>
  );
}

